import React, { useEffect } from 'react';
import { Button, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader, PopoverBody } from 'reactstrap';
import ScrollAreaWrapper from '../../UI/ScrollAreaWrapper';
import Moment from 'react-moment';
import { sumBy } from 'lodash';
import { UncontrolledPopover } from 'reactstrap/lib';

const TournamentPlayers = ({
    isOpen,
    toggle,
    tournamentPlayersArr,
    playersModalId,
    openPlayerHistoryModalFunc,
    openChatModalFunc,
    openChatModalMultipleFunc,
    openedPlayerTournament,
    selectedUsers,
    setSelectedUsers
}) => {
    useEffect(() => {
        if (isOpen) {
            deselectAllUsers();
        }
    }, [isOpen]);

    if (!isOpen) return null;

    const selectAllUsers = () => {
        if (!tournamentPlayersArr || !tournamentPlayersArr[playersModalId]) return;

        const allUids = tournamentPlayersArr[playersModalId].map(p => p.key);

        let updatedSelectedUsers = [...selectedUsers];
        for (const uid of allUids) {
            if (!selectedUsers.includes(uid)) {
                updatedSelectedUsers.push(uid);
            }
        }

        setSelectedUsers(updatedSelectedUsers);
    }
    const deselectAllUsers = () => {
        if (!tournamentPlayersArr || !tournamentPlayersArr[playersModalId]) return setSelectedUsers([]);
        const allUids = tournamentPlayersArr[playersModalId].map(p => p.key);
        const updatedSelectedUsers = selectedUsers.filter(uid => !allUids.includes(uid));
        setSelectedUsers(updatedSelectedUsers)
    }

    const toggleSelectedUser = (uid) => {
        let newSelectedUsers = [...selectedUsers];

        const index = newSelectedUsers.indexOf(uid);

        if (index !== -1) {
            newSelectedUsers.splice(index, 1);
        } else {
            newSelectedUsers.push(uid);
        }

        setSelectedUsers(newSelectedUsers);
    }

    const allUsersChecked = () => {
        if (!tournamentPlayersArr || !tournamentPlayersArr[playersModalId]) {
            return false;
        }

        const allUids = tournamentPlayersArr[playersModalId].map(p => p.key);

        for (const uid of allUids) {
            if (!selectedUsers.includes(uid)) {
                return false;
            }
        }
        return true;
    }

    const allUsersCheckedValue = allUsersChecked();

    return (
        <Modal container={'div > div'} size="xl" isOpen={isOpen} toggle={toggle} className="admin-page-modal">
            <ModalHeader toggle={toggle}>
                Players
            </ModalHeader>
            <ModalBody>
                <div className="tournament-players-table-wrapper">
                    {(tournamentPlayersArr && tournamentPlayersArr[playersModalId]) ? (
                        <table className="tournament-players-table" style={{ width: '100%' }}>
                            <colgroup>
                                <col span="1" />
                            </colgroup>
                            <thead className="tournaments-table-header-admin">
                                <tr>
                                    <th style={{ width: 12 }}>
                                        <Input style={{marginLeft: -3}}
                                            id="all"
                                            type="checkbox"
                                            onClick={allUsersCheckedValue ? deselectAllUsers : selectAllUsers}
                                            checked={allUsersCheckedValue}
                                        />
                                    </th>
                                    <th style={{ width: 24 }}>
                                        #
                                    </th>
                                    <th>
                                        Joined
                                    </th>
                                    <th>
                                        Name
                                    </th>

                                    <th style={{width: 223}}>
                                        Player Id
                                    </th>
                                    <th style={{width: 80}}>
                                        Tournament Points
                                    </th>
                                    <th style={{width: 40}}>
                                        Room Points
                                    </th>
                                    <th style={{width: 70}}>
                                        Status
                                    </th>
                                    <th>
                                        Winnings
                                    </th>
                                    <th>
                                        Balance Change
                                    </th>
                                    <th>
                                        Environment
                                    </th>
                                    <th>
                                        History
                                    </th>
                                    <th>
                                        Message
                                    </th>
                                    <th style={{width: 45}}>
                                        Leave reason
                                    </th>
                                </tr>
                            </thead>
                            <tbody className="tournaments-table-body-admin">
                                {tournamentPlayersArr[playersModalId].map((tournamentPlayer, index) => (
                                    <tr key={tournamentPlayer.key} className={`tournaments-table-row ${index % 2 === 0 ? ('odd') : ('even')}`}>
                                        <td className="tournaments-table-col" style={{ width: 12 }}>
                                            <Input style={{marginLeft: -3}} id={`toggleSelectedUser-${tournamentPlayer.key}`} type="checkbox" onClick={() => toggleSelectedUser(tournamentPlayer.key)} checked={selectedUsers.includes(tournamentPlayer.key)} readOnly />
                                        </td>
                                        <td className="tournaments-table-col" style={{ width: 24 }}>
                                            {index + 1}
                                        </td>
                                        <td className="tournaments-table-col">
                                            <Moment format="DD-MM-YYYY HH:mm" locale="lv">
                                                {tournamentPlayer.joinTime}
                                            </Moment>
                                        </td>
                                        <td className="tournaments-table-col">
                                            {`${tournamentPlayer.isAutomated ? '(B)' : ''} ${tournamentPlayer.name}`}
                                        </td>
                                        <td className="tournaments-table-col" style={{width: 223}}>
                                            {tournamentPlayer.uid}
                                        </td>
                                        <td className="tournaments-table-col" style={{width: 80}}>
                                            {tournamentPlayer.tournamentPoints}
                                        </td>
                                        <td className="tournaments-table-col" style={{width: 40}}>
                                            {tournamentPlayer.totalRoomPoints}
                                        </td>
                                        <td className="tournaments-table-col" style={{width: 70}}>
                                            {!tournamentPlayer.quit ? (tournamentPlayer.paused ? 'paused' : 'active') : 'left'}
                                        </td>
                                        <td className="tournaments-table-col">
                                            {tournamentPlayer.winnings}
                                        </td>
                                        <td className="tournaments-table-col">
                                            <div>{(tournamentPlayer.initialBal && tournamentPlayer.endBal) ? ((tournamentPlayer.endBal - tournamentPlayer.initialBal) - (tournamentPlayer.entryFee || 0) + (tournamentPlayer.winnings || 0)) : ''}</div>
                                        </td>
                                        <td className="tournaments-table-col">
                                            {tournamentPlayer.env}
                                        </td>
                                        <td className="tournaments-table-col">
                                            <Button className="allTournaments-table-col-button" color="primary" onClick={() => openPlayerHistoryModalFunc(playersModalId, tournamentPlayer.key)}>
                                                History
                                            </Button>
                                        </td>
                                        <td className="tournaments-table-col">
                                            <Button color="primary" onClick={() => openChatModalFunc(tournamentPlayer.uid, tournamentPlayer.name)}>
                                                Message
                                            </Button>
                                        </td>
                                        <td style={{width: 45}}>
                                            {tournamentPlayer.leaveReason ? (
                                                <>
                                                    <Button color="primary" id={`leave-reason-${tournamentPlayer.uid}`}>
                                                        ?
                                                    </Button>
                                                    <UncontrolledPopover popperClassName={`popover`} placement="right" trigger="focus" target={`leave-reason-${tournamentPlayer.uid}`}>
                                                        <PopoverBody className="popover-body">
                                                            {tournamentPlayer.leaveReason}
                                                        </PopoverBody>
                                                    </UncontrolledPopover>
                                                </>
                                            ) : (
                                                <>-</>
                                            )}
                                        </td>
                                    </tr>
                                ))}

                            </tbody>
                        </table>
                    ) : (null)}
                </div>

                {openedPlayerTournament === 'closed' && (
                    <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-around', marginTop: 10}}>
                        <Button
                            disabled={selectedUsers.length === 0}
                            style={{opacity: selectedUsers.length > 0 ? 1 : 0}}
                            onClick={() => openChatModalMultipleFunc()} className="mx-1"
                            >
                            Send message to selected players
                        </Button>

                        <div style={{fontSize: 12}}>
                            {`Total Balance Change: ${sumBy(tournamentPlayersArr[playersModalId], (item) => (((item.endBal || 0) - (item.initialBal)) - (item.entryFee || 0) + (item.winnings || 0)))}`}                            
                        </div>
                    </div>
                )}
            </ModalBody>
            <ModalFooter>
                <Button color="secondary" onClick={toggle}>Close</Button>
            </ModalFooter>
        </Modal>
    );
};

export default TournamentPlayers;